import React from "react";
import WarningIcon from "../../../../assets/img/Models/warning.svg"; // Adjust path to match your icon
import { CustomModal } from "../../../../revampComponents/Atom/Modals";
import NoteBox from "../../../../revampComponents/Atom/NoteBox/NoteBox";
const DeleteProfileModal = ({ show, onClose, onDelete, deleteLoader }) => {
  return (
    <CustomModal
      openModal={show}
      setOpenModal={onClose}
      width="400px"
      justifyContentForButtons="center"
      onOkay={onDelete}
      onCancel={onClose}
      saveBtnContent="Yes"
      isLoading={deleteLoader}
      cancelBtnContent="No"
      content={
        <div className="delete-modal-wrapper">
          <img src={WarningIcon} alt="Warning" className="warning-icon" />

          <div className="delete-title">Delete Profile</div>

          <div className="delete-subtitle">
            Do you want to delete the event profile?
          </div>

          <NoteBox>
            This action does not delete associated events and all the settings at
            the event level still remains intact.
          </NoteBox>

          <style>{`
            .delete-modal-wrapper {
              text-align: center;
              padding: 8px 0;
            }

            .warning-icon {
              width: 42px;
              height: 42px;
              margin-bottom: 16px;
            }

            .delete-title {
              font-size: 20px;
              font-weight: 600;
              color: #183b56;
              margin-bottom: 6px;
            }

            .delete-subtitle {
              font-size: 15px;
              color: #333;
              margin-bottom: 18px;
            }
          `}</style>
        </div>
      }
    />
  );
};

export default DeleteProfileModal;
